import script from "./LandingListTable.vue?vue&type=script&setup=true&lang=ts&generic=T%20%3D%20ITableRow"
export * from "./LandingListTable.vue?vue&type=script&setup=true&lang=ts&generic=T%20%3D%20ITableRow"

import "./LandingListTable.vue?vue&type=style&index=0&id=573d0ce2&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-573d0ce2"]])

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTr,QTh,QTd,QImg,QTable});
